import HTTP from '.';
import InformationPageServiceMock from './mocks/InformationPageService.mock';
import config from '@/config';

export default class InformationPageService {
  static getPageByName(args) {
    if (config.ENV.MOCK === true) {
      return InformationPageServiceMock.getPageByName(args.name);
    }

    return HTTP.get(
      `/api/pages/getByName?name=${args.name}&lang=${args.lang}`,
    );
  }
}
